import { Components, Theme } from "@mui/material/styles";

export const MuiCheckbox = () =>
  ({
    MuiCheckbox: {
      defaultProps: {
        color: "primary",
      },
    },
  }) satisfies Components<Theme>;
